// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container {
  width: 80%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2%;
}

.card {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: calc(18em + 160px);
  width: 25%;
  padding: 5px;
  margin: 4% auto;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  transform: translateY(20px);
  border-top: 2px solid #333;
  border-bottom: 2px solid #333;
  border-left: 2px solid #333;
  border-right: 2px solid #333;
  transition: opacity 1s ease-in-out;
}

.card.fade-in {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out, box-shadow 0.7s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card.fade-out {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out, box-shadow 0.7s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0);
}

.card:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.3);
}

.card-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: -5px;
  color: #333;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  padding-bottom: 10px;
  text-align: center;
}

.card-date {
  font-size: 0.9rem;
  color: #666;
}

.card-location {
  font-size: 1rem;
  color: #000000;
  margin-bottom: 5px;
  padding-bottom: 2px;
}

.card-description {
  font-size: 1rem;
  color: #444;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 5px;
}

.card-description-techs {
  margin-top: 5px;
  font-size: 19px;
  color: rgb(0, 0, 0);
}

.card-image {
  margin-top: 10px;
  width: 100%;
  height: 30%;
  object-fit: contain;
  border-radius: 5px;
  margin-bottom: 10px;
}

.card-status {
  font-size: 1rem;
  font-weight: lighter;
  color: rgb(0, 0, 0);
  border-radius: 5px;
}

.card-status.ongoing {
  color: green;
}

.card-status.terminated {
  color: red;
}

@media only screen and (max-width: 1300px) {
  .card {
    height: calc(16em + 70px);
    width: 25%;
    padding: 5px;
    margin: 4% auto;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
  }

  .card-image {
    margin-top: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .card-title {
    font-size: 1.2rem;
    margin-top: -10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    width: 100%;
    padding-bottom: 10px;
  }

  .card-date {
    font-size: 0.9rem;
    margin-top: -3px;
  }

  .card-location {
    font-size: 1rem;
    margin-bottom: 2px;
    padding-bottom: 0px;
  }

  .card-description {
    font-size: 1rem;
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .card-description-techs {
    margin-top: 5px;
    font-size: 19px;
  }

  .card-status {
    font-size: 1rem;
    margin-top: -5px;
  }
}

@media only screen and (max-width: 750px) {
  .card-container {
    margin-top: 70px;
    margin-bottom: 200px;
  }

  .card {
    height: calc(16em + 25px);
    width: 90%;
    padding: 5px;
    margin: 4% auto 50px auto; /* Add margin-bottom to separate cards */
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
  }

  .card-image {
    margin-top: 10px;
    width: 100%;
    height: auto;
    max-height: 150px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .card-title {
    font-size: 18px;
    margin-top: -10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    width: 100%;
    padding-bottom: 10px;
  }

  .card-date {
    font-size: 14px;
    margin-top: -3px;
  }

  .card-location {
    font-size: 16px;
    margin-bottom: 2px;
    padding-bottom: 0px;
    font-weight: bold;
  }

  .card-description {
    font-size: 15px;
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .card-status {
    font-size: 15px;
    margin-top: -5px;
    font-weight: bold;
  }
}


@media only screen and (max-width: 615px) {
  .card {
    height: calc(17em + 25px);
    width: 90%;
    padding: 5px;
    margin: 4% auto;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
  }

  .card-image {
    margin-top: 10px;
    width: 100%;
    max-height: 70px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .card-title {
    font-size: 16px;
    margin-top: -10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    width: 100%;
    padding-bottom: 10px;
  }

  .card-date {
    font-size: 12px;
    margin-top: -3px;
  }

  .card-location {
    font-size: 16px;
    margin-bottom: 2px;
    padding-bottom: 0px;
    font-weight: bold;
  }

  .card-description {
    font-size: 13px;
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .card-status {
    font-size: 15px;
    margin-top: -5px;
    font-weight: bold;
  }

  .card-description {
    font-size: 1rem;
    margin-top: 2px;
    margin-bottom: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Cards/cards-css/experience-card.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,OAAO;AACT;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,wCAAwC;EACxC,qDAAqD;EACrD,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,sFAAsF;EACtF,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,sFAAsF;EACtF,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,yBAAyB,EAAE,wCAAwC;IACnE,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;;AAGA;EACE;IACE,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');\n\n.card-container {\n  width: 80%;\n  margin: auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 2%;\n}\n\n.card {\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  height: calc(18em + 160px);\n  width: 25%;\n  padding: 5px;\n  margin: 4% auto;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  opacity: 0;\n  transform: translateY(20px);\n  border-top: 2px solid #333;\n  border-bottom: 2px solid #333;\n  border-left: 2px solid #333;\n  border-right: 2px solid #333;\n  transition: opacity 1s ease-in-out;\n}\n\n.card.fade-in {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out, box-shadow 0.7s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.card.fade-out {\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out, box-shadow 0.7s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n}\n\n.card:hover {\n  transform: scale(1.05);\n  transition: transform 0.2s ease;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.3);\n}\n\n.card-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-top: -5px;\n  color: #333;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #ccc;\n  width: 100%;\n  padding-bottom: 10px;\n  text-align: center;\n}\n\n.card-date {\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.card-location {\n  font-size: 1rem;\n  color: #000000;\n  margin-bottom: 5px;\n  padding-bottom: 2px;\n}\n\n.card-description {\n  font-size: 1rem;\n  color: #444;\n  text-align: center;\n  margin-top: 2px;\n  margin-bottom: 5px;\n}\n\n.card-description-techs {\n  margin-top: 5px;\n  font-size: 19px;\n  color: rgb(0, 0, 0);\n}\n\n.card-image {\n  margin-top: 10px;\n  width: 100%;\n  height: 30%;\n  object-fit: contain;\n  border-radius: 5px;\n  margin-bottom: 10px;\n}\n\n.card-status {\n  font-size: 1rem;\n  font-weight: lighter;\n  color: rgb(0, 0, 0);\n  border-radius: 5px;\n}\n\n.card-status.ongoing {\n  color: green;\n}\n\n.card-status.terminated {\n  color: red;\n}\n\n@media only screen and (max-width: 1300px) {\n  .card {\n    height: calc(16em + 70px);\n    width: 25%;\n    padding: 5px;\n    margin: 4% auto;\n    border-top: 1px solid #333;\n    border-bottom: 1px solid #333;\n    border-left: 1px solid #333;\n    border-right: 1px solid #333;\n  }\n\n  .card-image {\n    margin-top: 10px;\n    border-radius: 5px;\n    margin-bottom: 10px;\n  }\n\n  .card-title {\n    font-size: 1.2rem;\n    margin-top: -10px;\n    margin-bottom: 10px;\n    border-bottom: 1px solid #ccc;\n    width: 100%;\n    padding-bottom: 10px;\n  }\n\n  .card-date {\n    font-size: 0.9rem;\n    margin-top: -3px;\n  }\n\n  .card-location {\n    font-size: 1rem;\n    margin-bottom: 2px;\n    padding-bottom: 0px;\n  }\n\n  .card-description {\n    font-size: 1rem;\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n\n  .card-description-techs {\n    margin-top: 5px;\n    font-size: 19px;\n  }\n\n  .card-status {\n    font-size: 1rem;\n    margin-top: -5px;\n  }\n}\n\n@media only screen and (max-width: 750px) {\n  .card-container {\n    margin-top: 70px;\n    margin-bottom: 200px;\n  }\n\n  .card {\n    height: calc(16em + 25px);\n    width: 90%;\n    padding: 5px;\n    margin: 4% auto 50px auto; /* Add margin-bottom to separate cards */\n    border-top: 1px solid #333;\n    border-bottom: 1px solid #333;\n    border-left: 1px solid #333;\n    border-right: 1px solid #333;\n  }\n\n  .card-image {\n    margin-top: 10px;\n    width: 100%;\n    height: auto;\n    max-height: 150px;\n    border-radius: 5px;\n    margin-bottom: 10px;\n  }\n\n  .card-title {\n    font-size: 18px;\n    margin-top: -10px;\n    margin-bottom: 10px;\n    border-bottom: 1px solid #ccc;\n    width: 100%;\n    padding-bottom: 10px;\n  }\n\n  .card-date {\n    font-size: 14px;\n    margin-top: -3px;\n  }\n\n  .card-location {\n    font-size: 16px;\n    margin-bottom: 2px;\n    padding-bottom: 0px;\n    font-weight: bold;\n  }\n\n  .card-description {\n    font-size: 15px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n\n  .card-status {\n    font-size: 15px;\n    margin-top: -5px;\n    font-weight: bold;\n  }\n}\n\n\n@media only screen and (max-width: 615px) {\n  .card {\n    height: calc(17em + 25px);\n    width: 90%;\n    padding: 5px;\n    margin: 4% auto;\n    border-top: 1px solid #333;\n    border-bottom: 1px solid #333;\n    border-left: 1px solid #333;\n    border-right: 1px solid #333;\n  }\n\n  .card-image {\n    margin-top: 10px;\n    width: 100%;\n    max-height: 70px;\n    border-radius: 5px;\n    margin-bottom: 10px;\n  }\n\n  .card-title {\n    font-size: 16px;\n    margin-top: -10px;\n    margin-bottom: 10px;\n    border-bottom: 1px solid #ccc;\n    width: 100%;\n    padding-bottom: 10px;\n  }\n\n  .card-date {\n    font-size: 12px;\n    margin-top: -3px;\n  }\n\n  .card-location {\n    font-size: 16px;\n    margin-bottom: 2px;\n    padding-bottom: 0px;\n    font-weight: bold;\n  }\n\n  .card-description {\n    font-size: 13px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n\n  .card-status {\n    font-size: 15px;\n    margin-top: -5px;\n    font-weight: bold;\n  }\n\n  .card-description {\n    font-size: 1rem;\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
